/**
 * @generated SignedSource<<3848ab8ba84307c52100812d34d678eb>>
 * @relayHash d31d751b8d2df6b00dba2227445c1922
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 22c405c1466d19ac86bfc1ee91264decd40c73ed8fc34c324f886cba733f9321

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateNumberFieldInput = {
  id: string;
  operation: JiraNumberFieldOperationInput;
};
export type JiraNumberFieldOperationInput = {
  number?: number | null | undefined;
  operation: JiraSingleValueFieldOperations;
};
export type storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation$variables = {
  input: JiraUpdateNumberFieldInput;
};
export type storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation$data = {
  readonly jira: {
    readonly updateNumberField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly number: number | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateNumberField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly number: number | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation = {
  rawResponse: storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation$rawResponse;
  response: storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation$data;
  variables: storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraNumberFieldPayload",
        "kind": "LinkedField",
        "name": "updateNumberField",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          },
          {
            "concreteType": "JiraNumberField",
            "kind": "LinkedField",
            "name": "field",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "number"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "22c405c1466d19ac86bfc1ee91264decd40c73ed8fc34c324f886cba733f9321",
    "metadata": {},
    "name": "storyPointEstimate_issueFieldStoryPointEstimate_StoryPointEstimateField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "cd8233b80d650588112eb0d15d581a9c";

export default node;
